import { z } from 'zod';

/////////////////////////////////////////
// CETOPICS SCHEMA
/////////////////////////////////////////

export const cetopicsSchema = z.object({
  topicId: z.number().int(),
  cityId: z.number().int(),
  topicName: z.string(),
  nextReminder: z.string(),
  whenDue: z.string(),
  templateCode: z.string(),
  displayOrder: z.number().int(),
  fieldAttributes: z.string(),
  empFaqText: z.string(),
})

export type cetopics = z.infer<typeof cetopicsSchema>

export default cetopicsSchema;
